import { Component, Inject, OnInit } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { RetryDialogData } from '../../services/dialog.service';
import { ButtonComponent } from '../../../button/button.component';

@Component({
  selector: 'app-retry-dialog',
  standalone: true,
  imports: [ButtonComponent, ButtonComponent],
  templateUrl: './retry-dialog.component.html',
  styleUrl: './retry-dialog.component.scss',
})
export class RetryDialogComponent implements OnInit {
  countDownTimer!: number;

  constructor(
    @Inject(DIALOG_DATA) public data: RetryDialogData,
    public dialogRef: DialogRef<boolean>
  ) {}

  ngOnInit() {
    this.countDownTimer = this.data.timeUntilRetry ?? 5;
    const interval = setInterval(() => {
      this.countDownTimer = this.countDownTimer - 1;

      if (this.countDownTimer === 0) {
        clearInterval(interval);
        this.dialogRef.close(true);
      }
    }, 1000);
  }
}
